import { FC } from 'react'
import logo from './logo.svg'
import { cn } from '@wellesley/ui'
import { useIsOnline } from '@wellesley/network'
import { AppsLink } from '@wellesley/router'
import { WifiOff } from 'lucide-react'
type LogoProps = {
  className?: string
}
export const Logo: FC<LogoProps> = ({ className }) => {
  const isOnline = useIsOnline()

  return isOnline ? (
    <AppsLink to={'/'}>
      <img src={logo} className={cn('cursor-pointer', className)} />
    </AppsLink>
  ) : (
    <WifiOff size={40} className={cn('text-slate-400', className)} />
  )
}
